import { Box, Button, Typography, Paper, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import AddIcon from "@mui/icons-material/Add";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

export default function Farms({ translate, user, farms }) {
    const navigate = useNavigate();

    const handleFarmClick = (farm) => {
        navigate(
            farm.farm_status !== "active" ? "/farm-register" : "/farm",
            { state: { farm_id: farm.farm_id } }
        );
    };
    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: 4,
                p: 3,
                border: "1px solid rgba(0,0,0,0.08)",
                backgroundColor: "var(--color-bg-primary)",
                minHeight: 400,
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <AgricultureIcon sx={{ color: "var(--color-green-main)" }} />

                    <Typography
                        sx={{
                            fontFamily: "Fraunces",
                            fontSize: 26,
                            color: "var(--color-text-primary)",
                        }}
                    >
                        {translate("farms")}
                    </Typography>
                </Box>

                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => navigate("/farm-register")}
                    sx={{
                        backgroundColor: "var(--color-green-main)",
                        color: "var(--color-text-inverse)",
                        borderRadius: 3,
                        textTransform: "none",
                        px: 2,
                        "&:hover": {
                            backgroundColor: "var(--color-green-strong)",
                        },
                    }}
                >
                    {translate("create_farm")}
                </Button>
            </Box>

            <Box
                sx={{
                    flex: 1,
                    overflowY: "auto",
                    pr: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    minHeight: 0,
                    maxHeight: "65vh",
                }}
            >
                {!farms.length && (
                    <Typography sx={{ textAlign: "center", color: "text.secondary", py: 6 }}>
                        {translate("no_farms_yet")}
                    </Typography>
                )}

                {farms.map((farm) => (
                    <Paper
                        key={farm.farm_id}
                        elevation={0}
                        onClick={() => handleFarmClick(farm)}
                        sx={{
                            p: 2.5,
                            borderRadius: 4,
                            border: "1px solid rgba(0,0,0,0.08)",
                            backgroundColor: "var(--color-green-soft)",
                            cursor: "pointer",
                            transition: "0.2s ease",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            "&:hover": {
                                transform: "translateY(-2px)",
                                boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                            },
                        }}
                    >
                        <Box>
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: 18,
                                    color: "var(--color-text-primary)",
                                    mb: 0.5,
                                }}
                            >
                                {farm.farm_name}
                            </Typography>

                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                <LocationOnOutlinedIcon sx={{ fontSize: 16, color: "text.secondary" }} />

                                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                                    {farm.region}
                                </Typography>
                            </Box>
                        </Box>

                        <Chip
                            label={translate(farm.farm_status || "inactive")}
                            sx={{
                                borderRadius: 2,
                                backgroundColor:
                                    farm.farm_status === "active"
                                        ? "rgba(36,88,42,0.15)"
                                        : "rgba(0,0,0,0.08)",
                                color: "var(--color-text-primary)",
                                fontWeight: 600,
                            }}
                        />
                    </Paper>
                ))}
            </Box>
        </Paper>
    );
}